<template>
  <div class="sa-donation-row sa-donation-row--skeleton" aria-hidden="true">
    <div class="sa-donation-row-skeleton__avatar sa-skeleton" />
    <div class="sa-donation-row-skeleton__main">
      <div class="sa-donation-row-skeleton__line sa-donation-row-skeleton__line--title sa-skeleton" />
      <div class="sa-donation-row-skeleton__line sa-donation-row-skeleton__line--date sa-skeleton" />
    </div>
    <div class="sa-donation-row-skeleton__source sa-skeleton" />
    <div class="sa-donation-row-skeleton__amount sa-skeleton" />
  </div>
</template>
